import { Link, NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCallback, useEffect, useRef, useState } from 'react'
import { BitkiselLogo } from '../../assets'
import './Header.scss'

const LangOptions = [
  { value: 'ru', content: 'RU' },
  { value: 'en', content: 'EN' },
  { value: 'tr', content: 'TR' },
]

export default function Header() {
  const [t, i18n] = useTranslation('global')
  const location = useLocation()

  const handleLogoClick = () => {
    window.scrollTo(0, 0)
  }

  const onChangeLang = useCallback(
    (value: any) => {
      i18n.changeLanguage(value)
    },
    [i18n],
  )
  const onChangeHandler = (e: any) => {
    onChangeLang(e.target.value)
  }

  const [navbar, setNavbar] = useState(false)

  const changeBackground = () => {
    if (window.pageYOffset > window.innerHeight * 0.05) {
      setNavbar(true)
    } else {
      setNavbar(false)
    }
  }

  useEffect(() => {
    changeBackground()
    // adding the event when scroll change background
    window.addEventListener('scroll', changeBackground)
  })

  const navRef = useRef<HTMLDivElement>(null)

  const showNavbar = () => {
    const node = navRef.current
    node?.classList.toggle('header-navigation-responsive')
  }

  const [isOpen, setOpen] = useState(false)

  return (
    <header
      className={
        navbar ? 'header-wrapper header-wrapper-active' : 'header-wrapper'
      }
      style={
        // eslint-disable-next-line no-constant-condition
        location.pathname === '/about' || '/export'
          ? { background: 'rgba(0, 0, 0, 0.5)' }
          : { background: 'transparent' }
      }
    >
      <Link onClick={handleLogoClick} to="/">
        <img className="header-logo" src={BitkiselLogo} alt="logo" />
      </Link>
      <nav className="header-navigation" ref={navRef}>
        <NavLink
          className="header-navigation--link"
          onClick={showNavbar}
          to="/about"
        >
          {t('header.about')}
        </NavLink>
        <NavLink
          className="header-navigation--link"
          onClick={showNavbar}
          to="/export"
        >
          {t('header.export')}
        </NavLink>
        <NavLink
          className="header-navigation--link"
          onClick={showNavbar}
          to="contacts"
        >
          {t('header.contacts')}
        </NavLink>
        {/* <BasicSelect */}
        {/*  options={LangOptions} */}
        {/*  onChange={onChangeLang} */}
        {/*  value={i18n.language} */}
        {/* /> */}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div className="lang-select" onClick={() => setOpen(!isOpen)}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="lang-select--global-svg"
          >
            <path
              d="M18.1515 4.22768C18.1512 4.22123 18.1505 4.21478 18.1494 4.20838C18.1244 4.17267 18.0936 4.14194 18.0679 4.10694C17.8812 3.85257 17.6835 3.60775 17.4748 3.37243C17.4177 3.30812 17.3605 3.24453 17.3019 3.18165C17.0871 2.95161 16.8618 2.73224 16.626 2.52362C16.5824 2.48503 16.5417 2.44504 16.4981 2.40716C15.9169 1.90935 15.2806 1.47973 14.6017 1.12681C14.5745 1.11254 14.546 1.1004 14.5181 1.08608C14.2157 0.932438 13.9057 0.794327 13.5892 0.672376C13.5177 0.646671 13.4527 0.622347 13.3848 0.600913C13.1033 0.499475 12.8174 0.410639 12.5273 0.334403C12.4416 0.311545 12.3559 0.287976 12.2687 0.267964C11.9829 0.201525 11.6971 0.150786 11.4048 0.10934C11.3162 0.0964872 11.229 0.0793228 11.1397 0.0686055C10.387 -0.0228685 9.62592 -0.0228685 8.87314 0.0686055C8.78384 0.0793228 8.69667 0.0964872 8.60804 0.10934C8.3158 0.150786 8.02713 0.201525 7.74414 0.267964C7.65697 0.287976 7.57123 0.311545 7.48549 0.334403C7.19346 0.410597 6.90767 0.499433 6.62804 0.600913C6.55657 0.625194 6.49155 0.649517 6.42368 0.672376C6.1072 0.794327 5.79713 0.932396 5.49477 1.08608C5.46688 1.10036 5.43833 1.1125 5.41116 1.12681C4.72993 1.47936 4.09149 1.90893 3.50832 2.40716C3.46473 2.445 3.42399 2.48503 3.38041 2.52362C3.14223 2.7332 2.91689 2.95257 2.70446 3.18165C2.64588 3.24453 2.58869 3.30812 2.53154 3.37243C2.32242 3.60725 2.12472 3.85207 1.93849 4.1069C1.91278 4.1419 1.88205 4.17263 1.85702 4.20834C1.85375 4.21457 1.85086 4.22102 1.84843 4.22764C-0.616144 7.68133 -0.616144 12.3187 1.84843 15.7723C1.85086 15.7789 1.85371 15.7854 1.85702 15.7916C1.88201 15.8273 1.91274 15.8581 1.93849 15.8931C2.12476 16.1474 2.32242 16.3923 2.53154 16.6276C2.58869 16.6919 2.64588 16.7555 2.70446 16.8183C2.91978 17.0484 3.14507 17.2678 3.38041 17.4764C3.42399 17.515 3.46473 17.555 3.50832 17.5928C4.08944 18.0907 4.72574 18.5203 5.40471 18.8732C5.43188 18.8875 5.46043 18.8996 5.48832 18.9139C5.79069 19.0676 6.10071 19.2057 6.41723 19.3276C6.4887 19.3533 6.55372 19.3777 6.62159 19.3991C6.90311 19.5005 7.18894 19.5894 7.47904 19.6656C7.56478 19.6885 7.65053 19.712 7.7377 19.732C8.02353 19.7985 8.30931 19.8492 8.60159 19.8907C8.69018 19.9035 8.77735 19.9207 8.8667 19.9314C9.61943 20.0229 10.3805 20.0229 11.1332 19.9314C11.2225 19.9207 11.3097 19.9035 11.3983 19.8907C11.6906 19.8492 11.9793 19.7985 12.2622 19.732C12.3494 19.712 12.4352 19.6885 12.5209 19.6656C12.8134 19.5894 13.0992 19.5006 13.3783 19.3991C13.4498 19.3748 13.5148 19.3505 13.5827 19.3276C13.8992 19.2057 14.2093 19.0676 14.5116 18.9139C14.5395 18.8996 14.5681 18.8875 14.5952 18.8732C15.2742 18.5202 15.9105 18.0907 16.4916 17.5928C16.5352 17.555 16.5759 17.515 16.6195 17.4764C16.8577 17.2673 17.083 17.0479 17.2955 16.8183C17.3541 16.7555 17.4112 16.6919 17.4684 16.6276C17.6775 16.3923 17.8752 16.1474 18.0614 15.8931C18.0872 15.8581 18.1179 15.8273 18.1429 15.7916C18.1462 15.7854 18.1491 15.7789 18.1515 15.7723C20.6161 12.3187 20.6161 7.68138 18.1515 4.22768ZM17.3362 5.57953C18.0196 6.70489 18.4322 7.97355 18.5416 9.28558H14.2615C14.2091 8.43423 14.0751 7.5899 13.8614 6.76417C15.0704 6.53776 16.2407 6.13879 17.3362 5.57953ZM11.8214 1.62337C11.8614 1.63266 11.9 1.64552 11.94 1.65481C12.1958 1.71484 12.4495 1.78342 12.6974 1.86916C12.7353 1.88201 12.7724 1.89704 12.8096 1.9106C13.0554 1.99634 13.2976 2.09137 13.5349 2.19641C13.5763 2.21571 13.6171 2.23715 13.6585 2.25645C13.8857 2.36458 14.1077 2.48151 14.3245 2.60727L14.4674 2.69372C14.6731 2.81948 14.8732 2.95403 15.0676 3.09742C15.1176 3.13384 15.1676 3.16888 15.2169 3.20886C15.4075 3.35175 15.5899 3.50489 15.7643 3.66828C15.81 3.70973 15.8572 3.75046 15.9022 3.79333C16.0851 3.96695 16.2594 4.15056 16.4281 4.34063C16.4495 4.36562 16.4724 4.38848 16.4938 4.41209C15.5263 4.87315 14.5013 5.20237 13.4463 5.39093C12.9575 4.04741 12.3119 2.76627 11.5228 1.57414C11.622 1.59197 11.7235 1.60198 11.8214 1.62337ZM7.17114 9.28554C7.2275 8.51247 7.35913 7.74673 7.56415 6.99919C8.37375 7.09536 9.18832 7.14304 10.0036 7.14208C10.8197 7.14183 11.635 7.09293 12.4452 6.99559C12.6499 7.74434 12.7808 8.5113 12.836 9.28554H7.17114ZM12.836 10.7145C12.7797 11.4876 12.6481 12.2534 12.443 13.0009C11.6334 12.9047 10.8189 12.857 10.0036 12.858C9.18757 12.8571 8.37228 12.9048 7.56198 13.0009C7.35754 12.2533 7.22666 11.4876 7.1711 10.7145H12.836ZM10.0036 1.89206C10.8167 3.04446 11.4855 4.29223 11.995 5.60741C11.3335 5.67766 10.6688 5.71295 10.0036 5.71316C9.33909 5.71236 8.67507 5.67686 8.01427 5.6067C8.52439 4.2924 9.19238 3.04505 10.0036 1.89206ZM3.57987 4.33987C3.7478 4.14981 3.92285 3.96619 4.10577 3.79258C4.15077 3.74971 4.19796 3.70898 4.24368 3.66753C4.41994 3.50702 4.6024 3.35388 4.79101 3.20811C4.84033 3.17022 4.89032 3.13665 4.94035 3.09667C5.1347 2.95378 5.33479 2.81919 5.54057 2.69297L5.68346 2.60652C5.90021 2.47983 6.12219 2.36286 6.34941 2.25569C6.39086 2.23639 6.43159 2.21496 6.47304 2.19566C6.71026 2.08848 6.95251 1.99345 7.19832 1.90985C7.23545 1.89628 7.26978 1.88126 7.31048 1.8684C7.55842 1.78551 7.81067 1.71694 8.06791 1.65406C8.10793 1.64476 8.14649 1.63191 8.18723 1.62333C8.28511 1.60189 8.3866 1.59189 8.48591 1.57401C7.69646 2.76636 7.05061 4.04774 6.56164 5.39151C5.50661 5.20295 4.48161 4.87373 3.51413 4.41268C3.53557 4.38773 3.55843 4.36487 3.57987 4.33987ZM2.67096 5.57953C3.76626 6.13875 4.93625 6.53772 6.14505 6.76417C5.93157 7.58994 5.7978 8.43427 5.74564 9.28558H1.46555C1.575 7.97355 1.98764 6.70489 2.67096 5.57953ZM2.67096 14.4206C1.9876 13.2952 1.57495 12.0266 1.46555 10.7145H5.74564C5.79805 11.5659 5.93203 12.4102 6.14576 13.236C4.93675 13.4623 3.76651 13.8613 2.67096 14.4206ZM8.1858 18.3767C8.14578 18.3674 8.10722 18.3546 8.06719 18.3453C7.81138 18.2852 7.55771 18.2167 7.30977 18.1309C7.27188 18.1181 7.23474 18.103 7.19756 18.0895C6.95176 18.0037 6.70955 17.9087 6.47229 17.8037C6.43084 17.7844 6.3901 17.7629 6.34865 17.7436C6.12144 17.6355 5.89946 17.5186 5.68271 17.3928L5.53981 17.3064C5.33404 17.1806 5.13395 17.046 4.9396 16.9027C4.88957 16.8662 4.83958 16.8312 4.79026 16.7912C4.59972 16.6483 4.41726 16.4952 4.24292 16.3318C4.1972 16.2904 4.15002 16.2496 4.10501 16.2067C3.92209 16.0331 3.74776 15.8495 3.57911 15.6595C3.55768 15.6345 3.53482 15.6116 3.51338 15.588C4.4809 15.1269 5.50586 14.7977 6.56088 14.6092C7.04964 15.9527 7.69528 17.2338 8.4844 18.4259C8.38514 18.4082 8.28369 18.3981 8.1858 18.3767ZM10.0036 18.1081C9.19042 16.9557 8.52162 15.7079 8.01214 14.3927C9.33545 14.2503 10.6702 14.2503 11.9935 14.3927L11.9928 14.3934C11.4828 15.7077 10.8148 16.955 10.0036 18.1081ZM16.4273 15.6602C16.2594 15.8503 16.0843 16.0339 15.9014 16.2075C15.8564 16.2504 15.8092 16.2911 15.7635 16.3326C15.5872 16.4936 15.4048 16.6467 15.2162 16.792C15.1668 16.8298 15.1169 16.867 15.0668 16.9034C14.8725 17.0463 14.6724 17.1809 14.4666 17.3071L14.3237 17.3936C14.1074 17.5198 13.8854 17.6367 13.6578 17.7444C13.6163 17.7637 13.5756 17.7851 13.5341 17.8044C13.2969 17.9116 13.0547 18.0066 12.8089 18.0902C12.7717 18.1038 12.7374 18.1188 12.6967 18.1317C12.4488 18.2146 12.1965 18.2831 11.9393 18.346C11.8992 18.3553 11.8607 18.3682 11.82 18.3768C11.7221 18.3982 11.6206 18.4082 11.5213 18.4261C12.3104 17.2339 12.9561 15.9528 13.4448 14.6093C14.4998 14.7978 15.5248 15.1271 16.4923 15.5881C16.4716 15.6124 16.4487 15.6352 16.4273 15.6602ZM17.3362 14.4206C16.2409 13.8614 15.0709 13.4624 13.8621 13.236C14.0756 12.4102 14.2094 11.5659 14.2615 10.7145H18.5416C18.4322 12.0265 18.0195 13.2952 17.3362 14.4206Z"
              fill="#DADADA"
            />
          </svg>
          {LangOptions.find(({ value }) => value === i18n.language)?.content}
          <svg
            width="11"
            height="6"
            viewBox="0 0 11 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="lang-select--arrow-svg"
          >
            <path
              d="M1 0.75L5.5 5.25L10 0.75"
              stroke="#DADADA"
              strokeLinecap="round"
            />
          </svg>

          <div
            className={`select-menu ${isOpen ? 'select-menu--active' : ''}`}
            style={
              location.pathname === '/news'
                ? { background: 'rgba(0, 0, 0, 0.40)' }
                : { background: 'rgba(70, 70, 70, 0.5)', backdropFilter: 'blur(5px)' }
            }
          >
            <ul>
              <li className="lang-item">
                <button
                  className="lang-item--button"
                  type="button"
                  onClick={onChangeHandler}
                  value="ru"
                >
                  RU
                </button>
              </li>
              <li className="lang-item">
                <button
                  className="lang-item--button"
                  type="button"
                  onClick={onChangeHandler}
                  value="en"
                >
                  EN
                </button>
              </li>
              <li className="lang-item">
                <button
                  className="lang-item--button"
                  type="button"
                  onClick={onChangeHandler}
                  value="tr"
                >
                  TR
                </button>
              </li>
            </ul>
          </div>
        </div>
        <button
          className="header-navigation-btn header-navigation-close-btn"
          onClick={showNavbar}
          type="button"
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="8.08829"
              y1="8.00781"
              x2="21.356"
              y2="21.2756"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="21.3562"
              y1="8.08804"
              x2="8.08846"
              y2="21.3558"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </nav>
      <button
        className="header-navigation-btn"
        onClick={showNavbar}
        type="button"
      >
        <svg
          width="30"
          height="27"
          viewBox="0 0 30 27"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="30" height="4" rx="2" />
          <rect y="11" width="30" height="4" rx="2" />
          <rect y="23" width="30" height="4" rx="2" />
        </svg>
      </button>
    </header>
  )
}
